import React from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { NotFoundRoute } from './NotFoundRoute';
import { getPlayerViewId } from '../Player/utils/utils';
import { SuspenseWrapper } from './SuspenseWrapper';
import { PlayerContextProvider } from '../Player/PlayerContext';
import { useFetchPlayBackHistoryForItems } from '../../service/areena-api/hooks/useFetchPlayBackHistoryForItems';
import { isServiceId } from '../utils/item';
import { useFetchPlayerView } from '../hooks/useFetchPlayerView';

const PlayerRoute: React.FC = () => {
  const { itemId: unvalidatedItemId } = useParams();
  const [searchParams] = useSearchParams();
  const unvalidatedProgramId = searchParams.get('programId');
  const unvalidatedPublicationId = searchParams.get('publicationId');

  const itemId = unvalidatedItemId
    ? unvalidatedItemId.match(
        /(1-\d+|yle-tv1|yle-tv2|yle-teema-fem|yle-areena|yle-radio-1|ylex|yle-radio-suomi-[a-z]+|yle-puhe|radio-vega-[a-z]+|yle-x3m|yle-klassinen|yle-sami-radio|areena-audio-live)/
      )?.[0]
    : null;

  const programId = unvalidatedProgramId?.match(/(1-\d+)/)?.[0];
  const publicationId = unvalidatedPublicationId?.match(/(4-\d+)/)?.[0];
  const isSimulcast = itemId && isServiceId(itemId);

  const { data: playBackHistoryItems, isLoading: isHistoryLoading } =
    useFetchPlayBackHistoryForItems(
      itemId && !isSimulcast ? [itemId] : undefined
    );

  const { data: playerView, isLoading: isPlayerViewLoading } =
    useFetchPlayerView({
      itemId,
      programId,
      publicationId,
    });

  if (!itemId) {
    return <NotFoundRoute />;
  }

  const viewId = getPlayerViewId(itemId, publicationId);

  return (
    <SuspenseWrapper isLoading={isHistoryLoading || isPlayerViewLoading}>
      <AuthRequired>
        <PlayerContextProvider>
          <PlayerComponent
            playerView={playerView}
            playerViewId={viewId}
            itemId={itemId}
            durationWatched={playBackHistoryItems?.[itemId]}
          />
        </PlayerContextProvider>
      </AuthRequired>
    </SuspenseWrapper>
  );
};

const PlayerComponent = React.lazy(() => import('../Player/PlayerContainer'));
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

export default PlayerRoute;
